import env from "shared/env"
import I18n from "shared/i18n"
import {ProductFruits} from "react-product-fruits"
import React from "react"
import useCurrentUser from "@kaspernj/api-maker/build/use-current-user"

export default function ProductFruitsForApplication() {
  const currentUser = useCurrentUser()
  const user = React.useMemo(() => ({
    email: currentUser?.email(),
    firstname: currentUser?.firstName(),
    lastname: currentUser?.lastName(),
    signUpAt: currentUser?.createdAt(),
    username: user?.id() || "no-user"
  }), [currentUser?.id()])

  return (
    <ProductFruits language={I18n.locale} user={user} workspaceCode={env.PRODUCTFRUIT_CODE} />
  )
}
